import connection from "../../utils/connection";

const getUsuarioPermisos = async () => {
  let response = {};

  try {
    const responseGet = await connection({
      url: `/usuario-permisos`,
      method: "GET",
    });

    if (responseGet?.status === 401) {
      response = {
        status: 401,
        message: "No tiene permisos para realizar esta acción",
      };
    } else {
      response.data = responseGet;
    }
  } catch (error) {
    console.error("catch service getUsuarioPermisos", error);
    response = error.response;
    if (response?.status === 401) {
      response = {
        status: 401,
        message: "No tiene permisos para realizar esta acción",
      };
    }
  }

  return response;
};

export default getUsuarioPermisos;
